import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadCrump, BreadCrumpItem } from '../../shared/bread-crump/bread-crump';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, BreadCrump],
  templateUrl: './contact-us.html',
  styleUrl: './contact-us.scss',
})
export class ContactUs implements OnInit, OnDestroy {
  form!: FormGroup;
  langSubscription!: Subscription;
  
  items: BreadCrumpItem[] = [];

  categoryList = [
    { id: 'suggestion', nameAr: 'اقتراح', nameEn: 'Suggestion' },
    { id: 'complaint', nameAr: 'شكوى', nameEn: 'Complaint' },
    { id: 'contact', nameAr: 'تواصل', nameEn: 'Contact' },
  ];

  complexInfo: any = null;

  constructor(private fb: FormBuilder, public translate: TranslateService, private http: HttpClient, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initForm();
    this.updateTranslations();
    this.fetchComplexInfo();
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  ngOnDestroy(): void {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  private updateTranslations() {
    this.items = [
      { label: this.translate.instant('Nav.Home'), url: '/' },
      { label: this.translate.instant('contact.title'), url: '/contact-us' },
    ];
  }

  private fetchComplexInfo() {
    this.http.get<any>('/api/ComplexInfo', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    }).subscribe({
      next: (res) => {
        if (res && res.result && res.result.length > 0) {
          this.complexInfo = res.result[0];
          this.cdr.detectChanges();
        }
      },
      error: (err) => {
        console.error('Failed to fetch complex info', err);
      }
    });
  }

  /** Maximum allowed length for first/last name fields (enforced on front-end and sent as constraint to back-end) */
  readonly NAME_MAX_LENGTH = 50;

  private initForm() {
    const nameRegex = /^[\u0600-\u06FF\u0750-\u077Fa-zA-Z\s]{3,}$/;
    const phoneRegex = /^\+?[0-9]{7,15}$/;

    this.form = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(this.NAME_MAX_LENGTH), Validators.pattern(nameRegex)]],
      lastName:  ['', [Validators.required, Validators.maxLength(this.NAME_MAX_LENGTH), Validators.pattern(nameRegex)]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneRegex)]],
      subject: [''],
      category: [''],
      messsage: [''],
      attachements: [null]
    });
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const payload = {
        firstName: this.form.value.firstName,
        lastName: this.form.value.lastName,
        email: this.form.value.email,
        phoneNumber: this.form.value.phoneNumber,
        subject: this.form.value.subject,
        category: this.form.value.category,
        messsage: this.form.value.messsage
      };

      this.http.post('/api/ContactUsMessages', payload).subscribe({
        next: (res) => {
          alert('تم إرسال رسالتك بنجاح. شكراً لتواصلك معنا.');
          this.form.reset();
        },
        error: (err) => {
          console.error('Submit error:', err);
          alert('حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى.');
        }
      });
    }
  }
}
